import type {
  CLProductProperties,
  ClCommonDataLayer,
  ClEventPayload,
} from 'common/interfaces/customerLabs.interface';
import { CL_EVENT_NAMES } from '@/constants/CustomerLabs';
import { sendClEvent } from '@/CustomerLabs/ClUtils';

export const clPushAddedToCart = (
  common: ClCommonDataLayer,
  estOrderValue: number,
  productProperties?: CLProductProperties[]
) =>
  sendClEvent(
    CL_EVENT_NAMES.ADDED_TO_CART,
    {
      ...common,
      'Est Order Value': estOrderValue,
      value: estOrderValue,
      currency: 'USD',
    } as ClEventPayload,
    productProperties
  );

export const clPushAddedToStore = (
  common: ClCommonDataLayer,
  estOrderValue: number,
  productProperties?: CLProductProperties[]
) =>
  sendClEvent(
    CL_EVENT_NAMES.ADDED_TO_STORE,
    {
      ...common,
      'Est Order Value': estOrderValue,
      value: estOrderValue,
      currency: 'USD',
    } as ClEventPayload,
    productProperties
  );

export const clPushInitializeCheckout = (
  common: ClCommonDataLayer,
  estOrderValue: number,
  productProperties?: CLProductProperties[]
) =>
  sendClEvent(
    CL_EVENT_NAMES.INITIATE_CHECKOUT,
    {
      ...common,
      'Est Order Value': estOrderValue,
      value: estOrderValue,
      currency: 'USD',
    } as ClEventPayload,
    productProperties
  );

export const clPushPurchase = (
  common: ClCommonDataLayer,
  orderValue: number,
  orderId: number,
  transactionId: string | null,
  productProperties?: CLProductProperties[]
) =>
  sendClEvent(
    CL_EVENT_NAMES.PURCHASE,
    {
      ...common,
      'Order Value': orderValue,
      value: orderValue,
      currency: 'USD',
      order_id: orderId,
      transaction_id: transactionId,
    } as ClEventPayload,
    productProperties
  );
